import store from '@/store';
import { errorLog } from '@/utils/logger';
import stringToBoolean from '@/utils/stringToBoolean';

export default async (to, from, next) => {
  if (to.meta.public) return next();

  const { token: queryToken, multilogin } = to.query;

  if (queryToken) {
    try {
      await login(queryToken);
    } catch (err) {
      return next('/login');
    }
  }

  store.dispatch('auth/fetchAccessToken');

  const { accessToken, isLoggedIn } = store.state.auth;

  if (accessToken) {
    if (!isLoggedIn) {
      try {
        await login(accessToken);
      } catch (err) {
        return next('/login');
      }
    }

    if (multilogin) {
      store.dispatch('auth/setMultilogin', stringToBoolean(multilogin));
    }

    store.dispatch('auth/fetchMultilogin');
    return removeUsedParams(to, next);
  }

  next('/login');
};

const login = async token => {
  try {
    await store.dispatch('auth/login', token);

    const setProfessionalEnvironment = [
      store.dispatch('auth/fetchConfigs'),
      store.dispatch('auth/fetchUserServiceProfile'),
    ];
    await Promise.all(setProfessionalEnvironment);

    return Promise.resolve(true);
  } catch (err) {
    errorLog(err);
    return Promise.reject(err);
  }
};

const removeUsedParams = (to, next) => {
  const { token, multilogin, ...query } = to.query;
  const newTo = { ...to, query };

  if (token || multilogin) {
    return next(newTo);
  } else {
    return next();
  }
};
